import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { InsideSection } from '../components/sales/InsideSection';
import { PainSection } from '../components/sales/PainSection';
import { SolutionSection } from '../components/sales/SolutionSection';
import { VolumesSection } from '../components/sales/VolumesSection';
import { BeforeAfterSection } from '../components/sales/BeforeAfterSection';
import { AudienceSection } from '../components/sales/AudienceSection';
import { OfferSection } from '../components/sales/OfferSection';
import { FaqSection } from '../components/sales/FaqSection';
import { FinalSection } from '../components/sales/FinalSection';
import { SiteFooter } from '../components/sales/SiteFooter';
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-ivory font-body text-brand-charcoal" data-id="element-166" data-mp="1ttkfxykcud88">
      <header className="border-b border-brand-charcoal/10 bg-brand-paper" data-id="element-167" data-mp="3vn9zorwsafd4">
        <div className="mx-auto flex max-w-6xl items-center justify-center px-5 py-3 lg:px-8" data-id="element-168" data-mp="3vnjowda08ihr">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-charcoal" data-id="element-169" data-mp="3al1c2oavx6wc">
            Nail Educator Ready™ · Deutsche Ausgabe
          </p>
        </div>
      </header>

      <main data-id="element-170" data-mp="30ru8n8zpg0yw">
        <HeroSection data-id="element-171" data-mp="30rkf5bfgbbog" />
        <InsideSection data-id="element-172" data-mp="2vvc7sk7hwmru" />
        <PainSection data-id="element-173" data-mp="2vvvdn2jvfkpi" />
        <SolutionSection data-id="element-174" data-mp="2vwnb6ix13sif" />
        <VolumesSection data-id="element-175" data-mp="2vszj7o78fe5t" />
        <BeforeAfterSection data-id="element-176" data-mp="3tj44ld2n5lyw" />
        <AudienceSection data-id="element-177" data-mp="3th9me6ir87yi" />
        <OfferSection data-id="element-178" data-mp="3tghy7grhlci9" />
        <FaqSection data-id="element-179" data-mp="3ojhql1ezo1p1" />
        <FinalSection data-id="element-180" data-mp="3oj80zexuvwjv" />
      </main>

      <SiteFooter data-id="element-181" data-mp="3okarhlr9nwz9" />
    </div>;
}